module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请先验证密保卡")]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "m-form"
  }, [_c('form-item', {
    ref: "ppcValidate"
  }, [_c('ul', {
    staticClass: "m-ppc",
    attrs: {
      "id": "ppc-holder"
    }
  }, _vm._l((_vm.cards), function(c, index) {
    return _c('li', {
      ref: "cards",
      refInFor: true
    }, [_c('div', {
      staticClass: "ppc-up"
    }, [_c('div', {
      staticClass: "up-tlt",
      class: 'tlt' + (index + 1)
    }, [_vm._v(_vm._s(c))])]), _vm._v(" "), _c('div', {
      staticClass: "ppc-input"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "maxlength": "3",
        "autocomplete": "off",
        "spellcheck": "false"
      },
      on: {
        "input": function($event) {
          _vm.clearError(index)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-right",
    attrs: {
      "href": "https://gj.reg.163.com/faq/p4.html?ct=21"
    }
  }, [_vm._v("密保卡无法使用？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b398d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verifyppc.vue
// module id = 504
// module chunks = 1